import { IImageData, ImageData } from "src/app/features/image/models/image-data";
import { ILogosDto, logosDto } from "src/assets/common/models/logos-dto.g";

export const logosData = {
    logoData: 'logoData',
    logoThumbData: 'logoThumbData',
    logoEmailData: 'logoEmailData',
    logoIconPngData: 'logoIconPngData',
    logoIconSvgData: 'logoIconSvgData',
    logoFileBox_guid: 'logoFileBox_guid',
    folderShard:      'folderShard',
} as const;

export interface ILogosData {
    [logosData.logoData]: IImageData | null;
    [logosData.logoThumbData]: IImageData | null;
    [logosData.logoEmailData]: IImageData | null;
    [logosData.logoIconPngData]: IImageData | null;
    [logosData.logoIconSvgData]: IImageData | null;
    [logosData.logoFileBox_guid]: string | null;
    [logosData.folderShard]: string | null;
}

export class LogosData
    implements ILogosData
{
    [logosData.logoData]: IImageData | null = null;
    [logosData.logoThumbData]: IImageData | null = null;
    [logosData.logoEmailData]: IImageData | null = null;
    [logosData.logoIconPngData]: IImageData | null = null;
    [logosData.logoIconSvgData]: IImageData | null = null;
    [logosData.logoFileBox_guid]: string | null = null;
    [logosData.folderShard]: string | null = null;

    private constructor(modelDto: ILogosDto) {
        this[logosData.logoData] = ImageData.create(modelDto[logosDto.logoDto]) ?? null;
        this[logosData.logoThumbData] = ImageData.create(modelDto[logosDto.logoThumbDto]) ?? null;
        this[logosData.logoEmailData] = ImageData.create(modelDto[logosDto.logoEmailDto]) ?? null;
        this[logosData.logoIconPngData] = ImageData.create(modelDto[logosDto.logoIconPngDto]) ?? null;
        this[logosData.logoIconSvgData] = ImageData.create(modelDto[logosDto.logoIconSvgDto]) ?? null;
        this[logosData.logoFileBox_guid] = modelDto[logosDto.logoFileBox_Guid] ?? null;
        this[logosData.folderShard]      = modelDto[logosDto.folderShard]      ?? null;
    }

    static create(modelDto?: ILogosDto | null): LogosData | null {
        return modelDto ? new LogosData(modelDto) : null;
    }
}
